import { PropsWithChildren } from "react";
import UseNavbarHeight from "../../utilities/useNavbarHeight";

type props = {
  hideNav: boolean;
};

const BookSliderList = ({ hideNav, children }: PropsWithChildren<props>) => {
  const [navbarHeight] = UseNavbarHeight();

  return (
    <div
      className="books-sliders-list"
      data-hubs={hideNav}
      style={{ paddingTop: `${navbarHeight}px` }}
    >
      {children}
    </div>
  );
};

export default BookSliderList;
